import script from "./BulkApproveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkApproveModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkApproveModal.vue?vue&type=style&index=0&id=1a526bd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a526bd4"]])

export default __exports__